import React from 'react';
import styled from 'styled-components/macro';

import RadioGroup, { Radio } from 'components/base/RadioGroup/RadioGroup';
import { ILabelValuePair } from 'types/shared';
import Dropdown from '../Dropdown/Dropdown';

const TabsWrapper = styled('div')`
  margin-top: 0.5em;
`;

export const RadioGroupTabsWrapper = styled('div')`
  border-bottom: 1px solid ${({ theme }): string => theme.LightGrey};
  margin-top: 1.5em;

  ${Radio} {
    & + label {
      flex: 0 1 auto;
      padding: 1rem 3rem;
      background: transparent !important;
      text-transform: uppercase;
      color: ${({ theme }): string => theme.CasperGrey};
      line-height: 1;
      font-size: 1rem;

      @media screen and (max-width: 970px) {
        padding: 1rem 2rem;
      }

      @media screen and (max-width: 730px) {
        padding: 1rem 1rem;
      }
    }
    &:checked + label {
      position: relative;
      color: ${({ theme }): string => theme.NightBlue};

      &:after {
        position: absolute;
        top: 100%;
        display: block;
        width: 100%;
        height: 4px;
        background-color: ${({ theme }): string => theme.AccentGreen};
        content: '';
      }
    }
    &:hover:not(:checked) + label {
      background-color: ${({ theme }): string => theme.Sand} !important;
    }
  }
`;

interface ITabsProps {
  options: ILabelValuePair<string>[];
  selectedOption: string;
  onChange: (option: any) => void;
  componentName: string;
  isSmallScreen?: boolean;
  isRoundedDropdown?: string;
}

const Tabs: React.FC<ITabsProps> = (props) => {
  const {
    options,
    selectedOption,
    onChange,
    componentName,
    isSmallScreen,
    isRoundedDropdown,
  } = props;

  return (
    <TabsWrapper>
      {!isSmallScreen ? (
        <RadioGroupTabsWrapper>
          <RadioGroup
            name={componentName}
            options={options}
            selectedOption={selectedOption}
            onChange={onChange}
          />
        </RadioGroupTabsWrapper>
      ) : (
        <Dropdown
          items={options}
          selectedItem={options.find(
            (option) => option.value === selectedOption
          )}
          onChange={onChange}
          isActiveGreen
          isRoundedDropdown={isRoundedDropdown}
        />
      )}
    </TabsWrapper>
  );
};

export default Tabs;
